import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import Integrations from "../../../integration/Integrations.jsx";

class LightspeedOrderFromQuoteCreatedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            proposal: nextProps.proposal || null,
            quote: nextProps.quote || null,
        })
    }

    render() {
        let lightspeedUrl = Integrations.getExternalOrderUrl(this.state.object)
        return <div className={"row " + this.state.className}>
            <div className={'col-12'}>
                <p className={'mb-2'}>
                    <FormattedMessage
                        id="quote.analytics.events.order_created.text"
                        defaultMessage="The order {order} has been created from the quote {quote}"
                        values={{
                            order: <strong>
                                <a href={Integrations.getExternalOrderUrl(this.state.object)}>
                                    #{this.state.object.attributes.externalId}
                                </a>
                            </strong>,
                            quote: <strong>{this.state.quote.attributes.identifier}</strong>,
                        }}
                    />
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-3'}>
                    <a href={lightspeedUrl}>
                        <img src="/images/lightspeed_retail_logo.png" width="150px" />
                    </a>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <a href={lightspeedUrl} className={'btn btn-sm btn-outline-primary'}>
                            <FormattedMessage
                                id="invoice.analytics.events.order.ls_retail.open"
                                defaultMessage="Open sale in lightspeed"
                            />
                        </a>
                    </p>
                </div>
            </div>
        </div>
    }

}

export default LightspeedOrderFromQuoteCreatedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/order-from-quote-created-ls-retail.component.jsx